import {
  Box,
  Stack,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Pagination,
} from "@mui/material";

const PaginationControls = ({
  page,
  pagination,
  totalRecords,
  onPageChange,
  onPaginationChange,
}) => {
  return (
    <Box
      sx={{
        mt: 3,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="body2" color="text.secondary">
          Rows per page:
        </Typography>
        <FormControl size="small">
          <Select
            value={pagination}
            onChange={(e) => onPaginationChange(e.target.value)}
            sx={{ minWidth: 80 }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="body2" color="text.secondary">
          {`Showing ${Math.min(
            (page - 1) * pagination + 1,
            totalRecords
          )} - ${Math.min(page * pagination, totalRecords)} of ${totalRecords}`}
        </Typography>
      </Stack>
      <Pagination
        count={Math.ceil(totalRecords / pagination)}
        page={page}
        onChange={(event, value) => onPageChange(value)}
        color="primary"
        shape="rounded"
      />
    </Box>
  );
};

export default PaginationControls;
